'use strict';
const teamFileKey = params => {
		if (!params) {
			throw new Error('invalid-args');
		}

		const {userId, prefix, teamFileName} = params;
		if (!userId || !teamFileName) {
			throw new Error('invalid-args');
		}

		return `${(prefix || '')}${userId}/${teamFileName}`;
	},
	teamIdComponentsDelimiter = '_',
	applyAffiliateTeamId = team => {
		if (!team) {
			throw new Error('invalid-args');
		}
		if (team.teamId.includes(teamIdComponentsDelimiter)) {
			return team;
		}
		const teamId = [team.provider, team.teamId].join(teamIdComponentsDelimiter);
		return Object.assign({}, team, {teamId});
	},
	AUTO_IDENTITY = 'mindmup-auto',
	AUTO_ID_DELIMITER = '-',
	getAutoTeams = (owner, subteamRoles) => {
		if (!owner) {
			throw new Error('invalid-args');
		}
		const role = 'member',
			allowedActions = (subteamRoles && subteamRoles[role]) || [];
		return [
			applyAffiliateTeamId({
				provider: AUTO_IDENTITY,
				teamId: `${owner}${AUTO_ID_DELIMITER}everyone`,
				description: `all of ${owner}`,
				owner, role, allowedActions,
				isShareToAll: true
			})
		];
	};


module.exports = {
	affiliateTeamFileKey: params => {
		return teamFileKey(Object.assign({teamFileName: 'affiliateTeams.json'}, params));
	},
	subteamFileKey: params => {
		return teamFileKey(Object.assign({teamFileName: 'teamlist.json'}, params));
	},
	getAffiliateProvider: teamId => {
		if (!teamId) {
			throw new Error('invalid-args');
		}
		const teamIdComponents = teamId.split(teamIdComponentsDelimiter);
		return (teamIdComponents && teamIdComponents.length > 1 && teamIdComponents[0]) || false;
	},
	isAuto: (provider) => {
		return provider === AUTO_IDENTITY;
	},
	autoDescription: teamId => {
		const teamIdComponents = teamId.split(teamIdComponentsDelimiter),
			teamIdLocal = teamIdComponents[1],
			teamIdLocalComponents = teamIdLocal && teamIdLocal.split(AUTO_ID_DELIMITER),
			account = teamIdLocalComponents && teamIdLocalComponents[0],
			teams = account && getAutoTeams(account),
			team = teams && teams.find(ateam => ateam.teamId === teamId);
		return team && team.description;
	},
	applyAffiliateTeamId, getAutoTeams
};
